<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="size"
        :height="size"
        fill="currentColor"
        viewBox="0 0 200 150"
    >
        <path d="M117.6.9c-.4.5-1.9 6.1-3.5 12.5-6.2 24.6-14.8 32.9-40.2 39.2-17 4.2-17 6.3-.1 10.5 25.2 6.2 34.6 15.4 40.3 39.4 2.7 11.8 3.6 13.7 5.6 13.3 2.2-.4 2.7-1.8 5.2-12.7 5.5-24.3 15.2-33.8 40.3-40 5.9-1.5 11.2-3.1 11.8-3.7 2.4-2.4-.3-4.1-9.8-6.2-17.9-4.1-26.7-8.9-33.3-18.1-3.9-5.5-9-19-10.4-28.1-.4-2.5-1.2-5.1-1.7-5.8-1.2-1.4-3.4-1.6-4.2-.3m40.8 15.5c-.7 2.9-3.5 5.6-7.2 7.2l-2.7 1.1 3.8 1.6c2.8 1.2 4.3 2.7 5.6 5.7l1.9 4.2 1.8-3.9c1.3-2.5 3.2-4.4 5.8-5.7l3.9-1.9-4.4-2.1c-3.3-1.6-4.6-2.9-5.3-5.4-1.1-3.8-2.3-4.1-3.2-.8"/>
        <path d="M62.1 91.1c-.4 1.3-1.2 4-1.6 5.9-2.2 10.5-7.6 15.6-20 19-3.3 1-6.0 2.3-6.0 3s3.7 2.5 8.5 4c10.6 3.4 14.0 7.0 17.3 17.9 2.2 7.1 4.2 9.9 5.1 6.9.2-.7 1.2-4.1 2.1-7.5 3.0-10.4 9.2-16.0 20.5-18.4 7.0-1.5 6.4-3.7-1.5-5.8-3.3-.9-7.5-2.6-9.3-3.6-4.5-2.7-8.8-9.5-10.3-16.1s-3.4-8.7-4.8-5.3"/>
  </svg>
</template>

<script>
export default {
  name: 'IconIA',
  props: {
    size: {
      type: [Number, String],
      default: 18
    }
  }
}
</script>
